import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
  Avatar,
  Divider
} from '@mui/material';
import { useData } from '../../context/DataContext';
import QuoteIcon from '@mui/icons-material/FormatQuote';
import hospitalImage from '../../assets/homepageimages/hospital-image.webp';
import PageHero from './PageHero';

const CEOMessage = () => {
  const { state } = useData();
  const { pages, ceo } = state;
  const ceoData = ceo || pages['ceo-message'];

  return (
    <Box>
      <PageHero
        src={hospitalImage}
        alt="CEO Message"
        title={ceoData?.title || 'CEO Message'}
        subtitle="A message from our leadership"
      />

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6}>
          {/* CEO Image and Info */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: 'fit-content', p: 3 }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <Avatar
                  src={ceoData?.image}
                  alt={ceoData?.name || 'CEO'}
                  sx={{ 
                    width: 200, 
                    height: 200, 
                    mx: 'auto', 
                    mb: 3,
                    boxShadow: 3
                  }}
                />
                <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
                  {ceoData?.name || 'Maj.Gen. ® Mohammad Ashraf Khan'}
                </Typography>
                <Typography variant="h6" color="primary" gutterBottom>
                  {ceoData?.position || 'Chief Executive Officer'}
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" color="text.secondary">
                  {ceoData?.bio || 'Head of Department Anesthesia (MBBS, MCPS, DARCS & P (London) FFARCS (Dublin), FFARCS (Eng.))'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* CEO Message */}
          <Grid item xs={12} md={8}>
            <Card sx={{ height: '100%', p: 4 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                  <QuoteIcon sx={{ fontSize: 48, color: 'primary.main', mr: 2, mt: -1 }} />
                  <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
                    A Message from Our CEO
                  </Typography>
                </Box>
                
                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8, mb: 3 }}>
                  Hearts International Hospital (HIH) was established by a group of highly qualified Pakistani doctors with extensive training and credentials from the USA and UK. Their vision was to create a modern institution that is both patient- and physician-friendly, where quality health care is delivered in a compassionate, ethical, and professional manner.
                </Typography>

                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8, mb: 3 }}>
                  At Hearts International Hospital, we believe that healthcare is not just about treating illness, 
                  but about promoting wellness and improving the overall quality of life for our patients and 
                  their families. Our dedicated team of healthcare professionals works tirelessly to ensure 
                  that every interaction with our hospital is marked by compassion, expertise, and excellence.
                </Typography>

                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8, mb: 3 }}>
                  As we look to the future, we remain committed to our core values of patient-centered care, 
                  medical innovation, and community service. We will continue to invest in cutting-edge 
                  technology, attract the best medical talent, and expand our services to meet the evolving 
                  healthcare needs of our community.
                </Typography>

                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8, mb: 4 }}>
                  Thank you for choosing Hearts International Hospital for your healthcare needs. We are 
                  honored to serve you and your family, and we look forward to continuing our mission of 
                  providing exceptional healthcare services for many years to come.
                </Typography>

                <Box sx={{ textAlign: 'right' }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    {ceoData?.name || 'Maj.Gen. ® Mohammad Ashraf Khan'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {ceoData?.position || 'Chief Executive Officer'}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Leadership Commitment */}
        <Paper sx={{ p: 6, mt: 6, background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
          <Typography variant="h4" component="h2" gutterBottom textAlign="center" sx={{ mb: 4, fontWeight: 'bold' }}>
            Our Leadership Commitment
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h3" color="primary.main" sx={{ fontWeight: 'bold', mb: 2 }}>
                  30+
                </Typography>
                <Typography variant="h6" gutterBottom>
                  Years of Excellence
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Decades of providing exceptional healthcare services to our community
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h3" color="primary.main" sx={{ fontWeight: 'bold', mb: 2 }}>
                  50+
                </Typography>
                <Typography variant="h6" gutterBottom>
                  Expert Doctors
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Highly qualified medical professionals dedicated to patient care
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h3" color="primary.main" sx={{ fontWeight: 'bold', mb: 2 }}>
                  10,000+
                </Typography>
                <Typography variant="h6" gutterBottom>
                  Happy Patients
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Patients who have trusted us with their healthcare needs
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default CEOMessage; 